import { createRequest, RequestConfig } from 'app/common/api';

import { TPersonData } from '../core/person';

const config: RequestConfig = {
  method: 'post',
  url: '/ws/api/confirm_person_phone',
};

export const confirmPersonPhoneRequest = (body: {
  id: TPersonData['id'];
  code?: string;
}) =>
  createRequest({
    url: config.url,
    method: config.method,
    body: JSON.stringify(body),
  });
